// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3rMhe","col":"styles_col__1lKPv"};